import React, { useState, useEffect } from "react";
import Button from "../components/form/Button";
import Header from "../components/Header";
import axiosInstance from "../utils/axiosInstance";
import Session from "../utils/sessionStorage";
import SubscribePackageModal from "../components/SubscribePackageModal";
import { X_API_KEY } from "../constants/ServerUrl";
import ShimmerSkeleton from "../components/ShimmerSkeleton";
import { isAddPlanDisabled } from '../utils/profileutils';
import ErrorModal from "../components/ErrorModal";

const Plan = () => {
  const [loadingDataPakages, setLoadingDataPakages] = useState(true);
  const [plans, setPlans] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState(null);
  const [disableAddPlan, setDisableAddPlan] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataPrice, setDataPrice] = useState(null);
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const openModal = (packagename, price) => {
    setSelectedPackage(packagename);
    setDataPrice(price);
    setIsModalOpen(true);
    console.log("pakage ", packagename);
    console.log("price ", price);
  };
  console.log("pppp", disableAddPlan)

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedPackage(null);
    setDataPrice(null);
  };

  const token = Session.get("token");
  const profile = Session.get("_user_");
  const userData = profile ? JSON.parse(profile) : "";
  const saOrgName = userData?.saOrgName;

  useEffect(() => {
  const handlePageShow = () => {
    setIsModalOpen(false);
    setSelectedPackage(null);
    setDataPrice(null);
  };

  window.addEventListener("pageshow", handlePageShow);

  // fallback for cases where pageshow isn't reliable in some WebViews
  const handleVisibility = () => {
    if (document.visibilityState === "visible") {
      setIsModalOpen(false);
    }
  };
  document.addEventListener("visibilitychange", handleVisibility);

  return () => {
    window.removeEventListener("pageshow", handlePageShow);
    document.removeEventListener("visibilitychange", handleVisibility);
  };
}, []);

  const handleSubscribe = async () => {
    const userMob = userData.mobileNo;
    const userWalletId = userData.walletId;
    var body = {
      msisdn: userMob,
      package: selectedPackage,
      amount: dataPrice,
      wallet_id: userWalletId,
    };
    try {
      const url = disableAddPlan
        ? "api/v1/subscribe-package"
        : "api/v2/subscribe-package";
      const response = await axiosInstance.post(
        url,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            "X-API-KEY": X_API_KEY,
          },
        }
      );
      if (response.status === 200) {
        return { success: true, message: "Subscribed Successfully" };
      }
    } catch (error) {
      throw error;
    }
  };

  const handleDirectSubscribe = () => {
    const amountVal = Math.round(Number(dataPrice) * 100);
    const sAmt = amountVal;
    const sProdSubCode = String(amountVal).padStart(8, "0");
    const sBeneAcctNo = userData?.mobileNo;

    if (!dataPrice || !sBeneAcctNo || !saOrgName) {
      throw new Error("Unable to start direct subscription. Please try again.");
    }

    const url = `https://uat.onepay.com.my/dl/${saOrgName}/?OpName=VAS&ProdCode=09D&ProdSubCode=${sProdSubCode}&Amt=${sAmt}&BeneAcctNo=${sBeneAcctNo}`;
    window.location.href = url;
  };

  async function getDataPackage() {
    setLoadingDataPakages(true)
    try {
      const url = disableAddPlan
        ? "/api/v1/get-data-packages"
        : "/api/v2/get-data-packages";

      const response = await axiosInstance.get(url,
        {
          headers: {
            'X-API-KEY': X_API_KEY,
          },
        },
      );
      if (response.status === 200) {
        const { data_packages } = response?.data;
        setPlans(data_packages);
      }
    } catch (error) {
      setErrorMessage(error?.response?.data?.message || "Failed to load data packages");
      setShowError(true);
    } finally {
      setLoadingDataPakages(false)
    }
  }

  let handleValidity = (plans) => {
    if (plans === "Daily") {
      return "1 Day";
    } else if (plans === "Weekly") {
      return "7 Days";
    } else if (plans === "Monthly") {
      return "30 Days";
    }
  };

  useEffect(() => {
    if (disableAddPlan !== null) {
      getDataPackage();
    }
  }, [disableAddPlan]);

  useEffect(() => {
    setDisableAddPlan(isAddPlanDisabled());
  }, []);

  return (
    <div className="bg-accent-grey-50 h-screen lg:w-[450px] w-full mx-auto">
      {/* <div className="flex items-center h-[56px]   rounded-bl-lg rounded-br-lg bg-black "></div> */}
      <Header />
      {loadingDataPakages ? (<ShimmerSkeleton />) : (
        disableAddPlan ? (
          <div className="space-y-2.5 pt-6 mx-4">
            {/* <h1 className="text-2xl font-bold text-center">No Package Data</h1> */}
            {plans?.map((data, index) => {
              return (
                <div
                  key={index}
                  className=" px-4 py-6 flex flex-col gap-3  bg-[#2E31910D] h-auto rounded-[24px]"
                >
                  <div className="flex justify-between items-center">
                    <h3 className="text-primary font-semibold text-[17px]">
                      {data?.code}
                      <span className="inline font-light  text-gray">
                        {" "}
                        /
                      </span>
                      <p className="inline font-light text-sm text-gray">
                        {" "}
                        {handleValidity(data?.validity)}{" "}
                      </p>
                    </h3>

                    <span className="text-primary font-semibold text-[17px]">
                      RM {Number(data?.price).toFixed(2)}
                    </span>
                  </div>
                  <div className="border-t-[1px] border-[#1111111A]"></div>
                  <div className="space-y-1.5">
                    <div className="flex items-center gap-3 gap-x-6">
                      <div>
                        <p className="text-[13px] text-gray">Data</p>
                        <h3 className="flex justify-center items-center text-[13px] font-semibold">
                          {data.volume === "Unlimited" ? (
                            <span className="text-3xl pr-1"> &#8734;</span>
                          ) : (
                            (data.volume / 1024).toFixed(2)
                          )}{" "}
                          GB
                        </h3>
                        {/* <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12H4C4 16.418 7.582 20 12 20C16.418 20 20 16.418 20 12C20 7.582 16.418 4 12 4C9.25 4 6.824 5.387 5.385 7.5H8V9.5H2V3.5H4V6C5.824 3.57 8.729 2 12 2ZM13 7V11.585L16.243 14.828L14.828 16.243L11 12.413V7H13Z"
                        fill="#757575"
                      />
                    </svg> */}
                      </div>
                      <div>
                        {data.FreeVoice === "0" ? (
                          <></>
                        ) : (
                          <>
                            <p className="text-[13px] text-gray">
                              Voice Minutes
                            </p>
                            <h3 className="flex items-center text-[13px] font-semibold">
                              {data.FreeVoice === "unlimited" ? (
                                <span className="text-3xl pr-1"> &#8734;</span>
                              ) : (
                                data.FreeVoice
                              )}{" "}
                              Min
                            </h3>
                          </>
                        )}
                      </div>
                      {/* <p className="font-poppins text-sm text-accent-grey-900">
                    Validity:{" "}
                    <span className="font-poppins text-sm text-secondary font-normal">
                      {data?.validity}
                    </span>{" "}
                  </p> */}
                    </div>
                  </div>

                  <div className="flex justify-between items-center">

                    <Button
                      eventAction={() => openModal(data?.code, data?.price)}
                      type={"primary"}
                      // size={"xxlg"}
                      classes={"w-full py-2"}
                      children={"Subscribe"}
                    />
                  </div>
                </div>
              );
            })}
          </div>) : (
          <div className="space-y-2.5 pt-6 mx-4">
            {/* <h1 className="text-2xl font-bold text-center">No Package Data</h1> */}
            {plans?.map((data, index) => {
              return (
                <div
                  key={index}
                  className=" p-4 flex flex-col gap-3 bg-primary/5  h-auto rounded-[24px]"
                >
                  <div className="flex justify-between items-center">
                    <h3 className="text-primary font-semibold text-[17px]">
                      {data?.name}
                      <span className="inline font-light  text-gray">
                        {" "}
                        /
                      </span>
                      <p className="inline  text-sm text-gray">
                        {" "}
                        {handleValidity(data?.validity)}{" "}
                      </p>
                    </h3>
                    <span className="text-primary font-semibold text-[17px]">
                      RM {Number(data?.amount).toFixed(2)}
                    </span>
                  </div>
                  <div className="border-t-[1px] border-white"></div>
                  <div className="space-y-1.5">
                    <div className="flex items-center gap-3 gap-x-6">
                      <div>
                        <p className="text-[13px] text-gray">Detail</p>
                        <h3 className="flex justify-center items-center text-[13px] font-semibold">
                          {data.remarks}
                        </h3>
                        {/* <svg
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 2C17.523 2 22 6.477 22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12H4C4 16.418 7.582 20 12 20C16.418 20 20 16.418 20 12C20 7.582 16.418 4 12 4C9.25 4 6.824 5.387 5.385 7.5H8V9.5H2V3.5H4V6C5.824 3.57 8.729 2 12 2ZM13 7V11.585L16.243 14.828L14.828 16.243L11 12.413V7H13Z"
                        fill="#757575"
                      />
                    </svg> */}
                      </div>
                      {/* <div>
                      {data.FreeVoice === "0" ? (
                        <></>
                      ) : (
                        <>
                          <p className="text-[13px] text-accent-grey-900">
                            Voice Minutes
                          </p>
                          <h3 className="flex items-center">
                            {data.FreeVoice === "unlimited" ? (
                              <span className="text-3xl pr-1"> &#8734;</span>
                            ) : (
                              data.FreeVoice
                            )}{" "}
                            Min
                          </h3>
                        </>
                      )}
                    </div> */}
                      {/* <p className="font-poppins text-sm text-accent-grey-900">
                    Validity:{" "}
                    <span className="font-poppins text-sm text-secondary font-normal">
                      {data?.validity}
                    </span>{" "}
                  </p> */}
                    </div>
                  </div>

                  <div className="flex justify-between items-center">

                    <Button
                      eventAction={() => openModal(data?.name, data?.amount)}
                      type={"primary"}
                      classes={"w-full py-2"}
                      children={"Subscribe"}
                    />
                  </div>
                </div>
              );
            })}
          </div>
        )
      )}

      <div className="container">
        <div className="py-5"></div>
      </div>
      <SubscribePackageModal
        isOpen={isModalOpen}
        onClose={closeModal}
        onConfirm={handleSubscribe}
        onSecondaryConfirm={handleDirectSubscribe}
        packagename={selectedPackage}
        packageprice={dataPrice}
        secondaryLabel={"Direct Subscribe"}
        confirmLabel={"Airtime Subscribe"}
        buttonGridClasses="grid-cols-1"
        buttonsColorOrder="reverse"
      />
      {showError && <ErrorModal close={() => setShowError(false)} message={errorMessage} />}
    </div>
  );
};

export default Plan;
